import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginError from '@/views/LoginError'
import PermissionDenied from '@/views/PermissionDenied'
import CreateOrUpdateCredential from '@/views/credentials/CreateOrUpdateCredential'
import CredentialCertificates from '@/views/credentials/CredentialCertificates'
import Credentials from '@/views/credentials/Credentials'
import CredentialsAdmin from '@/views/credentials/CredentialsAdmin'
import Dashboard from '@/views/dashboard/Dashboard'
import AddDevice from '@/views/devices/AddDevice'
import Devices from '@/views/devices/Devices'
import UpdateDevice from '@/views/devices/UpdateDevice'
import License from '@/views/license/License'
import CreateOrUpdateUser from '@/views/users/CreateOrUpdateUser'
import UserProfile from '@/views/users/UserProfile'
import Users from '@/views/users/Users'
import Welcome from '@/views/welcome/Welcome'

import Role from '../Role'
import rdssUtil from '../services/api/rdssUtil'
import users from '../services/api/users'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: { layout: 'blank' }
  },
  {
    path: '/',
    redirect: 'Dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { allowedRoles: [Role.ADMIN, Role.USER] },
    beforeEnter(to, from, next) {
      if (store.state.remoteConfig.rdssPublicUrl) {
        next({ name: 'DashboardRDSS' })
      } else next()
    }
  },
  {
    path: '/dashboardRDSS',
    name: 'DashboardRDSS',
    component: Dashboard,
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        try {
          await rdssUtil.joinUserOnRdss()
        } catch (error) {
          console.log('Cant join rdss user')
        }
        const rdssPublicUrl = store.state.remoteConfig?.rdssPublicUrl ?? ''
        location.href = rdssPublicUrl + 'dashboard'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/dashboardRSSP',
    name: 'DashboardRSSP',
    component: Dashboard,
    meta: { allowedRoles: [Role.ADMIN, Role.USER] }
  },
  {
    path: '/documents',
    name: 'Documents',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureChains/list'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/allDocuments',
    name: 'AllDocuments',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureChains/administrator/list'
      }
    },
    meta: { allowedRoles: [Role.ADMIN], layout: 'blank' }
  },
  {
    path: '/recycleBinDocuments',
    name: 'RecycleBinDocuments',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureChains/administrator/recycleBin'
      }
    },
    meta: { allowedRoles: [Role.ADMIN], layout: 'blank' }
  },
  {
    path: '/signatureProfiles',
    name: 'SignatureProfiles',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureProfiles'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { allowedRoles: [Role.ADMIN] },
    children: [
      {
        path: '/users/add',
        name: 'CreateUser',
        components: { dialog: CreateOrUpdateUser },
        meta: { allowedRoles: [Role.ADMIN] }
      },
      {
        path: '/users/:userId/update',
        name: 'UpdateUser',
        components: { dialog: CreateOrUpdateUser },
        meta: { allowedRoles: [Role.ADMIN] }
      }
    ]
  },
  {
    path: '/users-rdss',
    name: 'Users RDSS',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'users'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/user/profilerdss',
    name: 'UserProfileRDSS',
    beforeEnter() {
      const rdssPublicUrl = store.state.config !== null ? store.state.remoteConfig.rdssPublicUrl : ''
      location.href = rdssPublicUrl + 'user/profile'
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/credentialsAdmin',
    name: 'CredentialsAdmin',
    component: CredentialsAdmin,
    meta: { allowedRoles: [Role.ADMIN] }
  },
  {
    path: '/importedCredentials',
    name: 'credentialsAdminImportedCredentials',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'importedCredentials'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/importedAlfaSignCredentials',
    name: 'CredentialsAlfaAdmin',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'importedAlfaSignCredentials'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/importedEvroTrustCredentials',
    name: 'CredentialsEvroAdmin',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'importedEvroTrustCredentials'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/credentialsRDSS',
    name: 'credentialsRDSS',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'credentials'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/trustx/process-instances',
    name: 'ProcessInstances',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'trustx/process-instances'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/business-account',
    name: 'BusinessAccount',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'business-account'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/business-account-admin',
    name: 'BusinessAccountAdmin',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'business-account-admin'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/user/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: { allowedRoles: [Role.ADMIN, Role.USER] },
    children: [
      {
        path: '/user/profile/:userId/update',
        name: 'ProfileUpdateUser',
        components: { dialog: CreateOrUpdateUser },
        meta: { allowedRoles: [Role.ADMIN, Role.USER] }
      },
      {
        path: '/user/profile/devices/:deviceId/update',
        name: 'ProfileUpdateDevice',
        components: { dialog: UpdateDevice },
        meta: { allowedRoles: [Role.USER] }
      },
      {
        path: '/user/profile/devices/add',
        name: 'ProfileAddDevice',
        components: { dialog: AddDevice },
        meta: { allowedRoles: [Role.USER] }
      }
    ]
  },
  {
    path: '/credentials',
    name: 'Credentials',
    component: Credentials,
    meta: { allowedRoles: [Role.ADMIN, Role.USER] },
    children: [
      {
        path: '/credentials/:userId?/add',
        name: 'CreateCredential',
        components: { dialog: CreateOrUpdateCredential },
        meta: { allowedRoles: [Role.ADMIN, Role.USER] }
      },
      {
        path: '/credentials/:userId?/:credentialId/update',
        name: 'UpdateCredential',
        components: { dialog: CreateOrUpdateCredential },
        meta: { allowedRoles: [Role.ADMIN, Role.USER] }
      }
    ]
  },
  {
    path: '/credentials/:userId?/:credentialId/certificates',
    name: 'CredentialCertificates',
    component: CredentialCertificates,
    meta: { allowedRoles: [Role.ADMIN, Role.USER] }
  },
  {
    path: '/devices',
    name: 'Devices',
    component: Devices,
    meta: { allowedRoles: [Role.ADMIN] },
    children: [
      {
        path: '/devices/:deviceId/update',
        name: 'UpdateDevice',
        components: { dialog: UpdateDevice },
        meta: { allowedRoles: [Role.ADMIN] }
      },
      {
        path: '/devices/add',
        name: 'AddDevice',
        components: { dialog: AddDevice },
        meta: { allowedRoles: [Role.ADMIN] }
      }
    ]
  },
  {
    path: '/signature-background',
    name: 'SignatureBackground',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signature-background'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/quantum-safe-demo',
    name: 'Quantum-safe Demo',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'quantum-safe-demo'
      }
    },
    meta: { layout: 'blank' }
  },
  {
    path: '/license',
    name: 'License',
    component: License,
    meta: { allowedRoles: [Role.ADMIN] }
  },
  {
    path: '/loginError',
    name: 'LoginError',
    component: LoginError,
    meta: { layout: 'blank' }
  },
  {
    path: '/permissionDenied',
    name: 'PermissionDenied',
    component: PermissionDenied,
    meta: { layout: 'blank' }
  },
  {
    path: '/notFound',
    name: 'NotFound',
    component: PermissionDenied,
    meta: { layout: 'blank' }
  },
  { path: '/logoutfromrdss' },
  { path: '/logoutOnlySelf' },
  { path: '/login-callback' },
  { path: '/logout' },
  {
    path: '*',
    redirect: 'NotFound'
  }
]

function createRouter(auth) {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })

  router.beforeEach(async (to, from, next) => {
    if (to.path === '/login-callback') {
      let state = null
      try {
        state = await auth.handleLoginCallback()
        const currentUser = await users.joinUser()
        store.commit('setCurrentUser', currentUser)
        const isStateString = typeof state === 'string' || state instanceof String
        if (isStateString) {
          next({ path: state, replace: true })
        } else {
          next({ name: state.name, replace: true })
        }
      } catch (error) {
        console.error('rssp logincallback exception', error)
        next({ name: 'Welcome' })
      }

      return
    }

    const user = await auth.getUser()

    if (to.name === 'Welcome') {
      if (user) {
        next({ name: 'Dashboard' })
      } else {
        next()
      }

      return
    }

    if (user) {
      const currentUser = await users.joinUser()
      store.commit('setCurrentUser', currentUser)

      const { allowedRoles } = to.meta

      if (allowedRoles) {
        let matchedRoles = []
        try {
          if (store.state.currentUser && store.state.currentUser.status !== 'SUSPENDED') {
            matchedRoles = store.state.currentUser.roles.filter(role => allowedRoles.includes(role))
          }
        } catch (error) {
          console.error(error)
          next({ name: 'PermissionDenied' })
          return
        }

        if (!matchedRoles.length) {
          next({ name: 'PermissionDenied' })
          return
        }
      }
    }

    if (to.path === '/logoutfromrdss') {
      try {
        // console.log('rssp router logoutfromrdss called')
        await auth.logoutOnlySelf()
        const rdssPublicUrl = store.state.remoteConfig?.rdssPublicUrl
        if (rdssPublicUrl) {
          location.href = rdssPublicUrl + 'dashboard'
        } else {
          next({ name: 'Welcome' })
        }
      } catch (error) {
        console.error('RSSP logoutfromrdss exception', error)
        next({ name: 'Welcome' })
      }

      return
    }

    if (to.path === '/logout') {
      try {
        // console.log('rssp router logout called')
        const logoutFromRDSSToo = !!store.state.remoteConfig.rdssApiUrl
        await auth.logoutAction(logoutFromRDSSToo)
      } catch (error) {
        console.error('RSSP logout exception', error)
        next({ name: 'Welcome' })
      }

      return
    }

    if (to.path === '/logoutOnlySelf') {
      try {
        // console.log('rssp router logoutOnlySelf called')
        await auth.logoutOnlySelf()
        const rdssPublicUrl = store.state.remoteConfig?.rdssPublicUrl
        if (rdssPublicUrl) {
          location.href = rdssPublicUrl + 'dashboard'
        } else {
          next({ name: 'Welcome' })
        }
      } catch (error) {
        console.error('RSSP logoutOnlySelf exception', error)
        next({ name: 'Welcome' })
      }

      return
    }

    if (!user && to.name !== 'Welcome') {
      await auth.login(to)
      return
    }

    next()
  })

  auth.addUserUnloaded(() => {
    router.push({ name: 'Welcome' })
  })

  return router
}

export default createRouter
